import { api } from '$lib/api.js';

export const APP_SETTING_SCOPES = {
  SYSTEM: 'system',
  USER: 'user'
};

function normalizeScope(scope) {
  return scope === APP_SETTING_SCOPES.SYSTEM ? APP_SETTING_SCOPES.SYSTEM : APP_SETTING_SCOPES.USER;
}

export async function loadAppSetting(key) {
  return api.get(`/api/app-settings/${encodeURIComponent(key)}`);
}

export async function saveAppSetting(key, value, scope = 'user', options = {}) {
  const payload = { scope: normalizeScope(scope), value };
  if (options.applyToAllUsers === true) {
    payload.applyToAllUsers = true;
  }

  return api.put(`/api/app-settings/${encodeURIComponent(key)}`, payload);
}

export async function resetAppSetting(key, scope = 'user') {
  return api.delete(`/api/app-settings/${encodeURIComponent(key)}?scope=${encodeURIComponent(normalizeScope(scope))}`);
}
